import React, { Component } from 'react';
import { AppConsumer } from '../components/AppContext';
import api from '../requests/api';
import Loader from '../components/Loader';
import { NotificationManager } from 'react-notifications';
import TopBar from '../components/TopBar';
import withTracker from "../utils/withTracker";

class CancelView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            cancelled: false,
            error: false
        };
    }

    async componentDidMount() {
        const { actions, state, t } = this.context;
        const urlParams = new URLSearchParams(window.location.search);

        const encodedCode = urlParams.get('s');

        if (!encodedCode) {
            NotificationManager.error(t('CancelView.NO_CODE_PROVIDED'));
            this.setState({ loading: false, error: true });
            return;
        }

        try {
            const turnCode = atob(encodedCode);

            await api.turn().cancel(turnCode);

            actions.resetActualTurn(true);
            actions.setTurnStatus('FINALIZED');

            NotificationManager.success(t('CancelView.TURN_CANCELLED_SUCCESS'));

            this.setState({
                loading: false,
                cancelled: true
            });

        } catch (error) {
            console.error('Error cancelling turn:', error);
            NotificationManager.error(t('CancelView.ERROR_CANCELLING'));
            this.setState({
                loading: false,
                error: true
            });
        }
    }

    goBack = () => {
        const { state } = this.context;
        if (state.selectedCompany) {
            this.props.history.push('/buscar/' + state.selectedCompany);
        } else {
            this.props.history.push('/');
        }
    }

    render() {
        const { loading, cancelled, error } = this.state;
        const { t, state } = this.context;

        return (
            <Loader loading={loading} fullscreen={false}>
                <div className="viewSearchCode">
                    <TopBar title={state.selectedCompany} />

                    {/* Vista de turno cancelado */}
                    {cancelled && (
                        <div className="turnView">
                            <div className="content finished">
                                <div className="viewSelectQueue__imgContainer">
                                    <div className="card card-info">
                                        <h2 className="deb-main-title finish-text" id="turnFinishTitle">
                                            <i className="fa fa-check-circle-o"></i> {t('CancelView.TURN_CANCELLED')}
                                        </h2>
                                        <p className="deb-text deb-text--center" id="turnFinishText">
                                            {t('CancelView.GO_BACK_HOME')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Vista de error */}
                    {error && (
                        <div className="content">
                            <div className="container-body">
                                <div className="card card-info">
                                    <div className="col search-container">
                                        <p className="deb-text">
                                            {t('CancelView.ERROR_MESSAGE')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </Loader>
        );
    }
}

CancelView.contextType = AppConsumer;
export default withTracker(CancelView);